import React from "react";
import Header from "../../components/Header/Header";
import Navbar from "../../components/NavBar/NavBar";
import data from "../../screens/Home/herbal.json";
import ItemList from "../../components/ItemList/ItemList";
import Footer from '../../components/Footer/Footer';
import ProductDiscription from "../../screens/ProductDiscription/ProductDiscription";


function Medicine() {
  return (
    <div>
      <Header />
      <Navbar />
      <div style={{ marginTop: "5%" }}>
        <ItemList data={data} />
      </div>
      <Footer />
    </div>
  );
}

export default Medicine;
